export default "__VITE_ASSET__44cf657e__"